module.exports = __webpack_public_path__ + "img/3a.7ae47b0f.jpg";